import React from 'react';
import { picturePropTypes } from './PicturePropTypes';
import PictureComponent from '@Theme/natucare/components/Picture/Picture';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './Picture.module.scss';
const Picture = ({
  src,
  alt,
  imgClassname
}) => {
  const hasPicture = !!src;
  if (hasPicture) {
    return /*#__PURE__*/React.createElement(PictureComponent, {
      alt: alt,
      pictureClassname: styles.root,
      imgClassname: `${styles.rootImage} ${imgClassname || ''}`,
      xs: {
        width: 350,
        height: 263,
        src: src
      }
    });
  }
  if (!hasPicture) {
    return /*#__PURE__*/React.createElement("div", {
      className: `${styles.root} ${styles.rootPlaceholder}`
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "placeholder",
      size: {
        width: 48,
        height: 48
      },
      classname: styles.rootIcon
    }));
  }
};
export default Picture;